import type { TMessages } from '@/types/TMessages'

export const messages = {
  header: 'Продажа урожая',
  subheader: 'Выбирайте из готовых предложений и продавайте свой урожай или создавайте заявку на своих условиях',
} satisfies TMessages
